<template>
  <div id="sign-success">
      <img class="logo" src="@/assets/fixed-invitation/logo.png" alt="">
      <!-- <h1 class="name">金果子</h1> -->
      <h1 class="title">{{ $t('sign.regist_success') }}</h1>
      <div class="down-btn" @click="goDown">
          {{ $t('sign.down_app') }}
          <img class="gift_box" src="@/assets/invitation-down/gift_box.png" alt="">
          <!-- <img class="gift" src="@/assets/invitation-down/gift.png" alt=""> -->
          <!-- <span class="gift-title">快下载领取积分奖励吧</span> -->
      </div>
  </div>
</template>

<script>
export default {
    name: 'SignSuccess',
    data() {
        
    },
    methods: {
        goDown() {
            if(this.$route.meta.from === 'fxh') {
                window.open(window.location.protocol + "//" + window.location.host + '/down-fromfxh')
            }
            window.open(window.location.protocol + "//" + window.location.host)
        }
    }
}
</script>

<style lang='less'>
#sign-success {
    height: 100vh;
    position: relative;
    background: #ffffff;
    padding: 100px 60px 0 60px;
    .logo {
        height: 100px;
        width: 100px;
        // margin-bottom: 40px;
    }
    h1 {
        line-height: 70px;
        font-size: 50px;
        font-weight: bold;
        // color: #FFA41F;
        
        &.name {
            margin-bottom: 80px;
        }
        &.title {
            margin-bottom: 300px;
            font-weight: 500;
        }
    }
    .down-btn {
        height: 88px;
        width: 630px;
        border-radius: 8px;
        line-height: 88px;
        background: #FFA41F;
        font-size: 34px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        .gift_box {
            height: 225px;
            width: 225px;
            right: 60px;
            bottom: 54px;
            z-index: 2;
            position: absolute;
        }
        .gift {
            height: 72px;
            width: 372px;
            right: 0;
            bottom: 80px;
            z-index: 2;
            position: absolute;
        }
        .gift-title {
            height: 72px;
            line-height: 72px;
            width: 372px;
            right: 0;
            bottom: 80px;
            z-index: 2;
            position: absolute;
            font-size: 32px;
        }
    }
}
</style>